import axios from 'axios';

export class ExchangeApiService {
	private baseUrl = '/api/exchange';

	async addToExchange(data: any): Promise<any> {
		const response = await axios.post(`${this.baseUrl}`, data);
		return response;
	}
}
